import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { C, A, O, T, useRespostaByPerguntaCode, FindPerguntaByCode } from 'shared/helpers';
import { renderables, editorRenderables } from 'shared/constants';

import { Creators as reduxProdutos } from 'store/ducks/produtos';
import { Creators as reduxEtapas } from 'store/ducks/etapas';
import { Creators as reduxPerguntas } from 'store/ducks/perguntas';
import { Creators as reduxRespostas } from 'store/ducks/respostas';

import Styles from './NutriçãoSQMV.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListOl, faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';

import Header from 'components/Header/Header';
import Table from 'components/Table/Table';
import Editor from 'components/NutritionalEditor/NutritionalEditor';
import ProductEditor from 'components/ProductEditor/ProductEditor';
import { useDatabaseSync } from 'shared/hooks';
import PrintButton from 'components/PrintButton/PrintButton';
import WithPermission from 'components/Template/WithPermission/WithPermission';

const INITIAL_PRODUCT_FORM = (user_id) => ({
  nome: '',
  classificacao: '',
  user_id,
  ...O(editorRenderables, A('', editorRenderables.length)),
});

export default function NutriçãoSQMV({ match }) {
  const { NutriçãoSQMV, Selected } = Styles;
  const { id } = match.params;
  const phase = 2;

  const dispatch = useDispatch();
  const [edit, toggleEdit] = useState(false);
  const [productCreator, toggleProductCreator] = useState(false);

  const user = useSelector((state) => state.user.data || {});
  const PEM = useSelector((state) => state.etapas.pem);
  const Perguntas = useSelector((state) => state.perguntas.data);
  const Respostas = useSelector((state) => state.respostas.data);
  const condition = useCallback(
    (p = {}) =>
      p.user_id === user.id ||
      p.user_id === null ||
      p.user_id === (PEM || {}).user_id,
    [user, PEM],
  );

  useDatabaseSync('etapas', () => reduxEtapas.getEtapas(id));
  useDatabaseSync('produtos', () => reduxProdutos.getProdutos(condition));

  useEffect(() => {
    dispatch(reduxEtapas.getEtapas(id));
    dispatch(reduxProdutos.getProdutos(condition));
    dispatch(reduxPerguntas.getPerguntas((pergunta) => pergunta.fase.id === phase));
    dispatch(
      reduxRespostas.getRespostas(
        (resposta) => String(resposta.pem_id) === String(id),
      ),
    );
    toggleEdit(false);
  }, [id, dispatch, condition]);

  const RProdutos = useSelector((state) => state.produtos.data);
  const REtapas = useSelector((state) => state.etapas.data);
  const notOnlyEtec = !T(T(user).roles, []).some((x) =>
    x.name.toLowerCase().includes('etec'),
  );

  const Produtos = RProdutos.map((x) => ({
    N: Number(x.NH2) + Number(x.NH4) + Number(x.NO3),
    ...x,
  }));

  const Etapas = REtapas.map((x) => ({
    ...x,
    produtos: x.produtos.filter((y) => y.fase_id === phase),
  }));

  const [form, setForm] = useState(INITIAL_PRODUCT_FORM(user.id));

  useEffect(() => {
    setForm(INITIAL_PRODUCT_FORM(user.id));
  }, [productCreator, user.id]);

  const addProduto = (form, etecStatus, id) => {
    dispatch(reduxProdutos.addProduto(form, !etecStatus, id));
  };

  const closeProduto = useCallback(() => toggleProductCreator(false), []);
  const tableRef = useRef();
  const quantidade = useRespostaByPerguntaCode(Perguntas, Respostas, 'quantidade_sqm');
  const pergunta = FindPerguntaByCode(Perguntas, 'quantidade_sqm');
  return (
    <div className={NutriçãoSQMV}>
      {id !== PEM ? null : (
        <ProductEditor
          open={productCreator}
          close={closeProduto}
          renderables={editorRenderables}
          form={form}
          etecStatus={!notOnlyEtec}
          submit={addProduto}
          setter={(e) => {
            const {
              target: { value, name },
            } = e;
            setForm((f) => ({ ...f, [name]: value }));
          }}
        />
      )}
      <Header icon={faListOl} title={'PROGRAMA NUTRICIONAL SQM VITAS BRASIL'}>
        <WithPermission permission='etapas.update'>
          <button
            id='editar'
            onClick={() => toggleEdit(!edit)}
            className={C([edit, Selected])}
          >
            <FontAwesomeIcon icon={faEdit} />
          </button>
        </WithPermission>
        <PrintButton fitElements={[tableRef]} />
      </Header>
      {id !== PEM ? null : (
        <main>
          {!edit ? (
            <Table
              tableRef={tableRef}
              renderables={renderables}
              etapas={Etapas}
              Produtos={Produtos}
              tableKey={'Next'}
              phase={phase}
              quantidade={quantidade}
            />
          ) : (
            <Editor
              id={Number(id)}
              renderables={renderables}
              etapas={REtapas}
              produtos={Produtos}
              tableKey={'Editor'}
              phase={phase}
              medida={quantidade}
              perguntaId={pergunta ? pergunta.id : undefined}
              setRefresh={(ref) => {
                toggleEdit(!ref);
              }}
            />
            )}
        </main>
      )}
      {edit && (
        <main style={{ height: '50px' }}>
          <button onClick={() => toggleProductCreator(true)}>
            <FontAwesomeIcon icon={faPlus} /> Criar produto
          </button>
        </main>
      )}
      {id !== PEM ? null : (
        <footer>
          <p>* micro elementos que podem ser quelatados</p>
        </footer>
      )}
    </div>
  );
}

NutriçãoSQMV.propTypes = {
  match: PropTypes.any.isRequired,
};
